export default __webpack_public_path__ + "static/media/3_prestige.aef3a5f0.svg";